import { Component, OnInit, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { FormatService } from '../../services/format/format.service';
import * as moment from "moment/moment";

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  isData : any = [];
  isTotalAll : number = 0;
  isKeyword : string = '';
  isVia : string = '';
  isStatus : string = '';
  isSubsFilter : string = ''; // '' = all, '1' = subscribed, '0' = not subscribed

  isPage : number = 1;
  isPageSize : number = 10;
  isPages : any = [];
  isTableLoading : boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.getData();
  }

  private searchTimer : any;
  private lastQuery : string = '';

  onKeywordInput(value : string){
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter(){
    clearTimeout(this.searchTimer);
    const query = `${this.isKeyword}|${this.isVia}|${this.isStatus}|${this.isSubsFilter}`;
    if(query === this.lastQuery){ return; } // query unchanged, skip the request
    this.lastQuery = query;
    this.isPage = 1;
    await this.getData();
  }

  async getData(){
    let searchData = {"keyword":this.isKeyword, "sign_with":this.isVia, "status":this.isStatus, "subscribed":this.isSubsFilter};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try{
      this.apiService.methodGetSilent(`user/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`,this.authService.getToken()).subscribe((response)=>{
        this.isTableLoading = false;
        if(response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            if(element.photo) {
              element.photoUrl = element.photo.includes('http') ? element.photo : `${response.directoryFile}user/avatar/${element.photo}`;
            }else{
              element.photoUrl = 'assets/images/no_avatar.webp';
            }
            element.lastSignVw = element.last_sign ? moment(element.last_sign).locale('id').format("D MMMM YYYY HH:mm") : '-';
            element.birthDateVw = element.birth_date ? moment(element.birth_date).locale('id').format("D MMMM YYYY") : '-';
            this.isData.push(element);
          }) : false);
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    }catch(error){
      this.isTableLoading = false;
      console.log(error);
    }
  }

  totalPages(){
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager(){
    const total = this.totalPages();
    const pages: any[] = [];
    for(let p = 1; p <= total; p++){
      if(p == 1 || p == total || Math.abs(p - this.isPage) <= 1){
        pages.push(p);
      }else if(pages[pages.length - 1] != '...'){
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any){
    const total = this.totalPages();
    if(p < 1 || p > total || p == this.isPage){ return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number){
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom(){
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo(){
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value : any){
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text : any){
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if(!keyword){ return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  // '-' fallback in one place instead of mutating the source data
  dash(value : any){
    return (value === null || value === undefined || value === '') ? '-' : value;
  }

  statusLabel(status : any){
    if(status == 1){ return 'Aktif'; }
    if(status == 0){ return 'Banned'; }
    return 'Dihapus';
  }

  // ===== detail dialog: full profile + status control =====
  isDetail : any = null;
  isNewStatus : string = '';

  openDetail(v : any){
    this.isDetail = v;
    this.isNewStatus = String(v.status);
    this.loadDetail(v.id);
    document.body.style.overflow = 'hidden'; // lock the page scroll behind the dialog
  }

  // ===== per-user extras the list payload deliberately omits (phone, subscription) =====
  isSubs : any = null; // null = loading, {failed} = fetch error, else {active, note}

  // deleted accounts: when the app API's purge job wipes (or wiped) the data
  isWipe : string = '';
  // latest device/app/region from the request-header usage log (90 days)
  isUsage : any = null;

  wipeNote(d : any) : string {
    const fmt = (v : any) => moment(v).locale('id').format('D MMMM YYYY');
    if (d.purged_at) { return `Data pribadi sudah dibersihkan pada ${fmt(d.purged_at)}.`; }
    if (d.deleted_at) {
      return `Data pribadi akan dibersihkan otomatis pada ${fmt(moment(d.deleted_at).add(30, 'days'))}.`;
    }
    return '';
  }

  usageView(u : any) : any {
    if (!u) { return null; }
    const platforms : any = {android: 'Android', ios: 'iOS', web: 'Web', tv: 'Android TV'};
    const region = [u.city, u.province].filter((x : any) => !!x).join(', ');
    return {
      device: [platforms[u.platform] || u.platform, u.device_model, u.os_version].filter((x : any) => !!x).join(' · '),
      version: u.app_version || '-',
      region: region || '-',
      mapUrl: u.lat != null && u.lng != null ? `https://www.google.com/maps?q=${u.lat},${u.lng}` : '',
      lastSeen: u.last_seen_at ? moment(u.last_seen_at).locale('id').format('D MMM YYYY, HH:mm') : '-',
      activeDays: u.active_days_30d || 0,
    };
  }

  loadDetail(id : any){
    this.isSubs = null;
    this.isWipe = '';
    this.isUsage = null;
    this.apiService.methodGetSilent(`user/detail/${id}`, this.authService.getToken()).subscribe((response : any)=>{
      if(!this.isDetail || this.isDetail.id != id){ return; } // dialog moved on — stale answer
      const d = (response && response.data) || {};
      this.isDetail.phone_number = d.phone_number;
      this.isWipe = this.wipeNote(d);
      this.isUsage = this.usageView(d.usage);
      const s = d.subscription || {};
      const sourceLabels : any = {voucher: 'Voucher', playstore: 'Play Store', appstore: 'App Store'};
      const until = s.expired_date ? moment(s.expired_date).locale('id').format('D MMMM YYYY') : '';
      this.isSubs = {
        active: !!s.active,
        note: s.source
          ? `${sourceLabels[s.source] || s.source} · ${s.active ? 'berakhir' : 'terakhir berakhir'} ${until}`
          : ''
      };
    }, ()=>{
      if(this.isDetail && this.isDetail.id == id){ this.isSubs = {failed: true}; }
    });
  }

  closeDetail(){
    if(this.isSaving || this.isConfirm || this.isGrant || this.isPremium){ return; } // never close under a running save / open overlay
    this.isDetail = null;
    document.body.style.overflow = '';
  }

  canEditStatus(){
    return this.isDetail && this.isDetail.status != 2; // a deleted account is final
  }

  // picking a different status asks for confirmation right away — no Save step
  onStatusPick(value : string){
    if(!this.canEditStatus() || value === String(this.isDetail.status)){ return; }
    this.isNewStatus = value;
    this.isConfirm = {
      mode: 'status',
      v: this.isDetail,
      from: String(this.isDetail.status),
      to: value,
    };
  }

  // ===== confirmation before anything actually changes =====
  isConfirm : any = null; // {mode: 'status', v, from, to} | {mode: 'password', v}
  isSaving : boolean = false;

  askResetPassword(){
    if(!this.isDetail || this.isDetail.status == 2){ return; }
    this.isConfirm = {mode: 'password', v: this.isDetail};
  }

  async confirmReset(){
    const c = this.isConfirm;
    if(!c || this.isSaving){ return; }
    this.isSaving = true;
    this.apiService.methodPutSilent(`user/reset-password/${c.v.id}`, {}, this.authService.getToken()).subscribe(async (response)=>{
      this.isSaving = false;
      if(response && response.status == 200) {
        this.isConfirm = null; // the detail dialog stays open — nothing in the list changed
        await this.toastr.success(`${c.v.name} — password baru: hatam165`, `Password direset`);
      } else {
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal mereset password`);
      }
    }, async () => {
      this.isSaving = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal mereset password`);
    });
  }

  closeConfirm(){
    if(this.isSaving){ return; } // never close while the save is in flight
    // cancelled status change: snap the segmented control back
    if(this.isConfirm && this.isConfirm.mode === 'status' && this.isDetail){
      this.isNewStatus = String(this.isDetail.status);
    }
    this.isConfirm = null;
  }

  async confirmStatus(){
    const c = this.isConfirm;
    if(!c || this.isSaving){ return; }
    this.isSaving = true;
    this.apiService.methodPutSilent(`user/status/${c.v.id}`, {status: c.to}, this.authService.getToken()).subscribe(async (response)=>{
      this.isSaving = false;
      if(response && response.status == 200) {
        this.isConfirm = null;
        this.isDetail = null;
        document.body.style.overflow = '';
        await this.toastr.success(
          `${c.v.name} — ${this.statusLabel(c.from)} menjadi ${this.statusLabel(c.to)}`,
          `Status diubah`);
        await this.getData(); // same page & filter, per playbook §2.5
      } else {
        // failure: keep the dialogs open so the user can retry
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal mengubah status`);
      }
    }, async () => {
      this.isSaving = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal mengubah status`);
    });
  }

  // ===== grant a voucher subscription (only offered while not subscribed) =====
  isGrant : any = null; // {step: 'pick'|'confirm', voucher}
  isGrantKeyword : string = '';
  isGrantList : any = [];
  isGrantLoading : boolean = false;
  isGrantSaving : boolean = false;
  private grantTimer : any;
  private lastGrantQuery : any = null;

  openGrant(){
    if(!this.isDetail || !this.isSubs || this.isSubs.active || this.isSubs.failed){ return; }
    this.isGrant = {step: 'pick', voucher: null};
    this.isGrantKeyword = '';
    this.lastGrantQuery = null;
    this.isGrantList = [];
    this.searchGrant();
  }

  onGrantKeyword(value : string){
    this.isGrantKeyword = value;
    clearTimeout(this.grantTimer);
    this.grantTimer = setTimeout(() => this.searchGrant(), 450);
  }

  searchGrant(){
    clearTimeout(this.grantTimer);
    if(this.isGrantKeyword === this.lastGrantQuery){ return; } // query unchanged, skip the request
    this.lastGrantQuery = this.isGrantKeyword;
    this.isGrantLoading = true;
    const src = encodeURIComponent(JSON.stringify({keyword: this.isGrantKeyword}));
    this.apiService.methodGetSilent(`user-voucher/available/${src}`, this.authService.getToken()).subscribe((response : any)=>{
      this.isGrantLoading = false;
      const rows = (response && response.data) || [];
      rows.forEach((v : any) => {
        v.endVw = moment().add(v.expired_day, 'days').locale('id').format('D MMMM YYYY');
      });
      this.isGrantList = rows;
    }, ()=>{
      this.isGrantLoading = false;
      this.isGrantList = [];
    });
  }

  pickGrant(v : any){
    this.isGrant = {step: 'confirm', voucher: v};
  }

  backGrant(){
    if(this.isGrantSaving){ return; }
    this.isGrant = {step: 'pick', voucher: null};
  }

  closeGrant(){
    if(this.isGrantSaving){ return; } // never close while the grant is in flight
    this.isGrant = null;
  }

  async confirmGrant(){
    const g = this.isGrant;
    if(!g || !g.voucher || this.isGrantSaving || !this.isDetail){ return; }
    this.isGrantSaving = true;
    const payload = {user_id: this.isDetail.id, voucher_id: g.voucher.id};
    this.apiService.methodPostSilent(`user-voucher`, payload, this.authService.getToken()).subscribe(async (response : any)=>{
      this.isGrantSaving = false;
      if(response && response.status == 200) {
        this.isGrant = null;
        this.isDetail.is_subscribed = 1; // the row object is shared with the table
        this.loadDetail(this.isDetail.id); // pill flips to Berlangganan with the real dates
        await this.toastr.success(`${this.isDetail.name} · ${g.voucher.code}`, `Voucher dipasangkan`);
      } else {
        // failure: keep the dialog open so the admin can retry or pick another voucher
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal memasangkan voucher`);
      }
    }, async () => {
      this.isGrantSaving = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal memasangkan voucher`);
    });
  }

  // ===== manual premium: grant (new) / extend (active) by day count =====
  isPremium : any = null; // {mode: 'grant'|'extend', days}
  isPremiumSaving : boolean = false;

  openPremiumGrant(){
    if(!this.isDetail || !this.isSubs || this.isSubs.active || this.isSubs.failed){ return; }
    this.isPremium = {mode: 'grant', days: 30};
  }

  openPremiumExtend(){
    if(!this.isDetail || !this.isSubs || !this.isSubs.active){ return; }
    this.isPremium = {mode: 'extend', days: 30};
  }

  closePremium(){
    if(this.isPremiumSaving){ return; } // never close while the request is in flight
    this.isPremium = null;
  }

  async confirmPremium(){
    const p = this.isPremium;
    const days = p ? Number(p.days) : 0;
    if(!p || !this.isDetail || this.isPremiumSaving || !days || days <= 0){ return; }
    this.isPremiumSaving = true;
    const endpoint = p.mode === 'grant' ? 'subscription-action/grant' : 'subscription-action/extend';
    const failLabel = p.mode === 'grant' ? 'Gagal memberikan premium' : 'Gagal memperpanjang premium';
    this.apiService.methodPostSilent(endpoint, {userId: this.isDetail.id, days}, this.authService.getToken()).subscribe(async (response : any)=>{
      this.isPremiumSaving = false;
      if(response && response.status == 200) {
        this.isPremium = null;
        this.isDetail.is_subscribed = 1; // the row object is shared with the table
        this.loadDetail(this.isDetail.id); // pill/note reflect the new expiry
        await this.toastr.success(`${this.isDetail.name} · ${days} hari`, p.mode === 'grant' ? 'Premium diberikan' : 'Premium diperpanjang');
        await this.getData();
      } else {
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, failLabel);
      }
    }, async () => {
      this.isPremiumSaving = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, failLabel);
    });
  }

  // ===== manual premium: revoke (reuses the status/password confirm dialog) =====
  openPremiumRevoke(){
    if(!this.isDetail || !this.isSubs || !this.isSubs.active){ return; }
    this.isConfirm = {mode: 'revoke', v: this.isDetail};
  }

  async confirmRevoke(){
    const c = this.isConfirm;
    if(!c || this.isSaving){ return; }
    this.isSaving = true;
    this.apiService.methodPostSilent(`subscription-action/revoke`, {userId: c.v.id}, this.authService.getToken()).subscribe(async (response : any)=>{
      this.isSaving = false;
      if(response && response.status == 200) {
        this.isConfirm = null;
        await this.toastr.success(`${c.v.name}`, `Premium dicabut`);
        this.loadDetail(c.v.id);
        await this.getData();
      } else {
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal mencabut premium`);
      }
    }, async () => {
      this.isSaving = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal mencabut premium`);
    });
  }

  copyText(text : string){
    const done = () => this.toastr.success(`${text} disalin`);
    const nav: any = navigator;
    if(nav.clipboard && nav.clipboard.writeText){
      nav.clipboard.writeText(text).then(done);
    }else{
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    }
  }

  // ===== full-size photo viewer (lightbox) =====
  isViewer : string = '';

  openViewer(url : string){
    if(!url){ return; }
    this.isViewer = url;
    document.body.style.overflow = 'hidden'; // lock the page scroll behind the viewer
  }

  closeViewer(){
    this.isViewer = '';
    document.body.style.overflow = this.isDetail ? 'hidden' : ''; // detail may still be open underneath
  }

  @HostListener('document:keydown.escape')
  onEscape(){
    if(this.isViewer){ this.closeViewer(); return; }
    if(this.isPremium){ this.closePremium(); return; }
    if(this.isGrant){ this.closeGrant(); return; }
    if(this.isConfirm){ this.closeConfirm(); return; }
    if(this.isDetail){ this.closeDetail(); }
  }
}
